import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    purpose: String
  }

  static targets = [ "term", "cell", "mode", "factory" ]

  purposeValueChanged() {
    // Silos and factory both use simple code-based locations
    const isSimpleLocation = this.purposeValue === "silos" || this.purposeValue === "factory"
    const isFactory = this.purposeValue === "factory"

    this.termTargets.forEach((input) => {
      input.disabled = !isSimpleLocation
    })
    this.modeTargets.forEach((radio) => {
      radio.disabled = isSimpleLocation
    })
    this.cellTargets.forEach((container) => {
      // Hide the container by setting display style directly
      if (isSimpleLocation) {
        container.style.display = "none"
      } else {
        container.style.display = ""
      }
      // Disable the input field inside
      const input = container.querySelector('input[type="text"]')
      if (input) {
        input.disabled = isSimpleLocation
      }
    })

    // Show factory products field only for factory locations
    this.factoryTargets.forEach((container) => {
      container.style.display = isFactory ? "" : "none"
    })
  }

  changePurpose(event) {
    this.purposeValue = event.target.value
  }
}